import { ConversationParticipant, Message } from '@/types/chat.type'

export interface MessageViewer {
  id: number
  user: {
    firstName: string
    lastName: string
    avatar?: string
    profileId?: string
    id?: number
  }
  readAt: string | null
}

export const getMessageViewers = (
  message: Message,
  participants: ConversationParticipant[]
): MessageViewer[] => {
  if (!participants || participants.length === 0) return []

  const messageTime = new Date(message.updatedAt || message.createdAt).getTime()

  return participants
    .filter(participant => {
      if (participant.user.id === message.sender.id) return false
      if (!participant.lastReadAt) return false

      const lastReadTime = new Date(participant.lastReadAt).getTime()
      return lastReadTime >= messageTime
    })
    .map(participant => ({
      id: participant.id,
      user: participant.user,
      readAt: participant.lastReadAt,
    }))
}

export const formatViewerHoverText = (viewers: MessageViewer[], maxNames = 2): string => {
  if (viewers.length === 0) return ''

  const formatName = (viewer: MessageViewer) => `${viewer.user.firstName} ${viewer.user.lastName}`
  const displayedViewers = viewers.slice(0, maxNames)

  if (viewers.length <= maxNames) {
    return `${displayedViewers.map(formatName).join(', ')} đã xem`
  }

  return `${displayedViewers.map(formatName).join(', ')} và những người khác đã xem`
}
